package org.example.newportfolio.utils


object Res {

    object Strings {
        const val START_SECTION_TITLE = "Software Engineer - Mobile Developer"
        const val START_SECTION_SUBTITLE = "Dedicated to turning your innovative idea into a high-quality mobile reality."
        const val START_SECTION_BUTTON_TEXT = "Explore my works"
        const val SCROLL_HINT = "Scroll"

        const val WORKS_SECTION_TITLE = "Explore my works"
        const val WORKS_SECTION_SUBTITLE = "All projects are primarily developed with Kotlin. It's a powerful cross-platform language and Google's preferred language for Android development."

        const val ABOUT_SECTION_TITLE = "About me"
        // Updated summary: concise professional mobile developer summary
        const val ABOUT_SECTION_SUBTITLE = "Mobile Developer specialized in performant Android & cross‑platform apps (Kotlin, Compose, Flutter, KMP). I focus on clean architecture, scalable code and solving real performance & UX problems."

        const val CONTACT_SECTION_TITLE = "Contact me"

        const val EMAIL_ADDRESS = "mohamed.abdelazim.elgohary@gmail.com"
        const val TELEGRAM_USERNAME = "@MohamedElgohary88"

        const val EMAIL_LINK = "mailto:$EMAIL_ADDRESS"
        const val GITHUB_LINK = "https://github.com/MohamedElgohary88"
        const val TELEGRAM_LINK = "https://t.me/MohamedElgohary88"
        const val LINKEDIN_LINK = "https://www.linkedin.com/in/mohamed-elgohary8"

        const val COPYRIGHT = "© 2024, Mohamed Elgohary"
    }

    object FontFamilies {
        const val POPPINS_REGULAR = "PoppinsRegular"
        const val POPPINS_MEDIUM = "PoppinsMedium"
    }

    object Images {
        const val LOGO_DARK = "images/logo_dark.svg"
        const val LOGO_LIGHT = "images/logo_light.svg"

        const val START_IMAGE = "images/start_image.svg"

        const val ANDROID_STUDIO = "images/android_studio.svg"
        const val KOTLIN = "images/kotlin.svg"
        const val KTOR = "images/ktor.svg"
        const val FIGMA = "images/figma.svg"
        const val INTELLIJ_IDEA = "images/intellij_idea.svg"
        const val JAVA = "images/java.svg"
        const val FIREBASE = "images/firebase.svg"
        const val POSTGRESQL = "images/postgresql.svg"
        const val JETPACK_COMPOSE = "images/compose.svg"
        const val GITHUB_LIGHT = "images/github_light.svg"
        const val GITHUB_DARK = "images/github_dark.svg"
        const val MAIL_LIGHT = "images/mail_light.svg"
        const val MAIL_DARK = "images/mail_dark.svg"
        const val TELEGRAM_LIGHT = "images/telegram_light.svg"
        const val TELEGRAM_DARK = "images/telegram_dark.svg"
        const val LINKEDIN_LIGHT = "images/linkedin_light.svg"
        const val LINKEDIN_DARK = "images/linkedin_dark.svg"

        const val HONEY_MART = "images/hony.svg"
        const val TEAMIX = "images/teamix.svg"
        const val SKY_CAST = "images/weather.svg"
        const val MOVIE = "images/movie.svg"
        const val BLOG = "images/blog.svg"
        const val HOTEL = "images/hotel.svg"
        const val BISMAR = "images/bismar.svg"
        const val FLUTTER = "images/flutter.svg"
        const val DART = "images/dart.svg"
        const val GRADLE = "images/gradle.svg"
        const val GRAPHQL = "images/graphql.svg"
        const val REALM = "images/realm.svg"
        const val SQLITE = "images/sqlite.svg"
        const val MONGODB = "images/mongodb.svg"
        const val POSTMAN = "images/postman.svg"
        const val GITLAB = "images/git_lab.svg"
        const val SWIFT = "images/swift.svg"
        const val APPLE = "images/apple.svg"
        const val ADOBE_XD = "images/adobe_xd.svg"
        const val SLACK = "images/slack.svg"
    }
}